import { css } from "@emotion/css"
import { Trans } from "@lingui/react/macro"

export const DROP_HAR_TIPS = (
  <div
    className={css`
      display: flex;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      z-index: 1000;
      align-items: center;
      justify-content: center;
    `}
  >
    <div>
      <Trans>Drop your HAR file here…</Trans>
    </div>
  </div>
)
